/* Source community panels and media, scoped to their real section roots. */
(function () {
  'use strict';
  if (window.NarwalCommunity) return;
  const states = new Map();
  window.NarwalCommunity = { states };
  function setup(root) {
    if (states.has(root)) return;
    const abort = new AbortController(), swipers = new Map(), observers = [], frames = new Set();
    const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: abort.signal });
    const tabs = [...root.querySelectorAll('.ndev-community-hub-tabs__title')];
    const later = fn => { const id = requestAnimationFrame(() => { frames.delete(id); if (!abort.signal.aborted) fn(); }); frames.add(id); };
    function navigation(panel, swiper) {
      const el = swiper.el, buttons = panel.querySelector('.ndev-community-hub__nav-buttons');
      if (!buttons) return;
      const show = el.querySelector('.swiper-wrapper').scrollWidth > el.offsetWidth + 1;
      buttons.classList.toggle('show', show); buttons.setAttribute('aria-hidden', String(!show));
    }
    function ensure(panel, reset) {
      const el = panel.querySelector('.swiper-container');
      if (!el || typeof Swiper === 'undefined') return;
      let swiper = swipers.get(panel);
      if (!swiper) {
        swiper = new Swiper(el, { slidesPerView: 'auto', initialSlide: 0, spaceBetween: 0,
          speed: matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : 300,
          navigation: { nextEl: panel.querySelector('.ndev-community-hub__nav-button--next'), prevEl: panel.querySelector('.ndev-community-hub__nav-button--prev') } });
        swipers.set(panel, swiper);
      }
      later(() => later(() => { swiper.update(); if (reset) swiper.slideTo(0, 0); navigation(panel, swiper); }));
    }
    function sync() {
      tabs.forEach(tab => {
        const panel = document.getElementById(tab.getAttribute('target'));
        if (!panel) return;
        const active = tab.hasAttribute('open'), changed = active !== panel.classList.contains('is-active');
        panel.classList.toggle('is-active', active); panel.setAttribute('aria-hidden', String(!active));
        if (active) ensure(panel, changed);
        else {
          panel.querySelectorAll('video').forEach(v => v.pause());
          panel.querySelectorAll('[data-ndev-youtube-media-card]').forEach(card => {
            card.querySelectorAll('iframe').forEach(f => f.remove());
            const button = card.querySelector('[node-name="play"]'); if (button) button.hidden = false;
          });
        }
      });
      root.querySelectorAll('[data-ndev-chub-faq-trigger]').forEach(tab => {
        const open = tab.hasAttribute('open');
        document.getElementById(tab.getAttribute('target'))?.classList.toggle('active', open);
        tab.setAttribute('aria-expanded', String(open));
      });
    }
    root.querySelectorAll('[data-ndev-chub-faq]').forEach(faq => {
      const single = faq.dataset.singleOpen === '1', name = faq.dataset.accordionName;
      faq.querySelectorAll('[data-ndev-chub-faq-trigger]').forEach(tab => {
        if (single && name) tab.setAttribute('name', name); else tab.removeAttribute('name');
        tab.setAttribute('role', 'button'); tab.setAttribute('aria-controls', tab.getAttribute('target'));
      });
    });
    const observer = new MutationObserver(sync);
    observer.observe(root, { subtree: true, attributes: true, attributeFilter: ['open'] });
    on(window, 'resize', () => swipers.forEach((s, panel) => { s.update(); navigation(panel, s); }));
    root.querySelectorAll('ui-tab').forEach(tab => on(tab, 'keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); tab.click(); }
      else if (tabs.includes(tab) && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        event.preventDefault(); const group = tabs.filter(t => t.getAttribute('name') === tab.getAttribute('name'));
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? group.length - 1 : (group.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : group.length - 1)) % group.length;
        group[index].focus(); group[index].click();
      }
    }));
    root.querySelectorAll('[data-ndev-instagram-media-card]').forEach(card => {
      const videos = [...card.querySelectorAll('video')], button = card.querySelector('[node-name="play"]');
      if (videos.length === 1) videos[0].classList.remove('pc-done', 'mobile-done');
      if (!button) return;
      const current = () => videos.find(v => v.getClientRects().length);
      function caption() {
        const video = current(), paused = !video || video.paused;
        if (!paused) card.classList.add('off');
        const play = button.querySelector('[node-name^="play_"]'), pause = button.querySelector('[node-name^="pause_"]');
        if (play && pause) { play.classList.toggle('hide', !paused); pause.classList.toggle('hide', paused); }
        else button.textContent = paused ? 'Воспроизвести' : 'Приостановить';
        button.setAttribute('aria-label', paused ? 'Воспроизвести видео' : 'Приостановить видео');
      }
      videos.forEach(video => {
        ['play', 'pause', 'ended'].forEach(type => on(video, type, caption));
        const io = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }); io.observe(video); observers.push(io);
      });
      on(window, 'resize', () => { videos.filter(v => !v.getClientRects().length).forEach(v => v.pause()); caption(); });
      on(button, 'click', () => {
        const video = current(); if (!video) return;
        if (!video.currentSrc) { video.querySelectorAll('source[data-src]').forEach(s => s.src = s.dataset.src); video.poster = video.dataset.poster || ''; video.load(); }
        video.controls = true;
        if (video.paused) video.play().catch(caption); else video.pause();
      }); caption();
    });
    root.querySelectorAll('[data-ndev-youtube-media-card]').forEach(card => {
      const button = card.querySelector('[node-name="play"]'), target = card.querySelector('[data-ndev-youtube-embed]');
      if (!button || !target) return;
      on(button, 'click', () => {
        if (target.firstElementChild || !target.dataset.nwbYoutubeSrc) return;
        const iframe = document.createElement('iframe'), url = new URL(target.dataset.nwbYoutubeSrc);
        url.searchParams.set('autoplay', '1'); iframe.src = url.href; iframe.title = 'Видео клиента Narwal';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture'; iframe.allowFullscreen = true; iframe.style.cssText = 'width:100%;height:100%;border:0';
        target.append(iframe); button.hidden = true;
      });
    });
    on(document, 'visibilitychange', () => { if (document.hidden) root.querySelectorAll('video').forEach(v => v.pause()); });
    sync();
    states.set(root, { destroy() { abort.abort(); observer.disconnect(); observers.forEach(o => o.disconnect()); frames.forEach(cancelAnimationFrame); swipers.forEach(s => s.destroy(true, true)); root.querySelectorAll('video').forEach(v => v.pause()); root.querySelectorAll('iframe').forEach(f => f.remove()); states.delete(root); } });
  }
  function card(root) {
    if (states.has(root)) return;
    const abort = new AbortController(), box = root.querySelector('.ndev-closable-product-intro__product-card'), close = root.querySelector('[data-ndev-closable-product-intro-close]'), open = root.querySelector('.ndev-closable-product-intro__card-reopen');
    if (!box || !close || !open) return;
    close.addEventListener('click', () => { box.classList.add('is-collapsed'); open.focus({ preventScroll: true }); }, { signal: abort.signal });
    open.addEventListener('click', () => { box.classList.remove('is-collapsed'); close.focus({ preventScroll: true }); }, { signal: abort.signal });
    states.set(root, { destroy() { abort.abort(); states.delete(root); } });
  }
  function scan(scope) { scope.querySelectorAll('[data-ndev-community-hub]').forEach(setup); scope.querySelectorAll('.ndev-closable-product-intro').forEach(card); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true }); else scan(document);
  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => { for (const [root, state] of states) if (e.target.contains(root)) state.destroy(); });
}());
